
import React from 'react';
import { cn } from '@/lib/utils';
import { useIsMobile } from '@/hooks/use-mobile';

interface MobileContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  withBottomPadding?: boolean;
  fullHeight?: boolean;
  centerContent?: boolean;
}

export const MobileContainer = ({ 
  className, 
  children, 
  withBottomPadding = false,
  fullHeight = false,
  centerContent = false,
  ...props 
}: MobileContainerProps) => {
  const isMobile = useIsMobile();
  
  return (
    <div 
      className={cn(
        'container mx-auto px-4', 
        isMobile ? 'mobile-container' : '',
        withBottomPadding && isMobile ? 'mobile-bottom-padding' : '',
        fullHeight ? 'min-h-[calc(100vh-4rem)]' : '',
        centerContent ? 'flex flex-col items-center justify-center' : '',
        className
      )} 
      {...props}
    >
      {children}
    </div>
  );
};

interface MobileFixedBottomProps extends React.HTMLAttributes<HTMLDivElement> {
  showOnlyOnMobile?: boolean;
}

export const MobileFixedBottom = ({ 
  className, 
  children,
  showOnlyOnMobile = true,
  ...props 
}: MobileFixedBottomProps) => {
  const isMobile = useIsMobile();
  
  if (showOnlyOnMobile && !isMobile) {
    return null;
  }
  
  return (
    <div 
      className={cn(
        'mobile-fixed-bottom',
        className
      )} 
      {...props}
    >
      {children}
    </div>
  );
};
